import React, { Component } from 'react'
import classNames from 'classnames'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import RenderProfilePicture from '../../../../_helpers/profile-picture'

class Online extends Component
{
  constructor(props) {
    super(props)

    this.state = {
      onlineUser: props.user
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({
        onlineUser: this.props.user
      })
    }
  }

  render () {
    const profileClass = classNames({
      'user-online': this.state.onlineUser.typing === false
    })

    return <div className="mr-1">
      <OverlayTrigger
        overlay={<Tooltip>{`${this.state.onlineUser.firstName} ${this.state.onlineUser.lastName} Active`}</Tooltip>}
      >
        <div>
          <RenderProfilePicture height={25} width={25} image={this.state.onlineUser.profileUrl} circle cached={true} className={profileClass} />
          { this.state.onlineUser.typing &&
            <div className="typing">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
            </div>
          }
        </div>
      </OverlayTrigger>
    </div>
  }
}

export default Online